<!-- 预约历史页面 -->
<template>
  <div class="appointment-history">
    <div class="appointment-history__header">
      <div class="appointment-history__header__search">
        <van-search
          v-model="form.filter"
          show-action
          label=""
          placeholder="请输入患者姓名、医生、科室"
          @search="onSearch"
          @clear="onSearch">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </div>
      <div>
        <el-row>
          <el-col :span="12">
            <div class="">
              <van-field
                border
                readonly
                clickable
                name="picker"
                :value="bookingType"
                label="类型"
                label-width="30px"
                placeholder="点击选择类型"
                right-icon="arrow-down"
                @click="typePickerShow = true" />
              <van-popup v-model="typePickerShow" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="typeList"
                  value-key="label"
                  @confirm="onTypePickerConfirm"
                  @cancel="typePickerShow = false" />
              </van-popup>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="">
              <van-field
                readonly
                clickable
                name="picker"
                label-width="30px"
                :value="bookingStatus"
                label="状态"
                right-icon="arrow-down"
                placeholder="点击选择状态"
                @click="statusPickerShow = true" />
              <van-popup v-model="statusPickerShow" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="statusList"
                  value-key="label"
                  @confirm="onStatusPickerConfirm"
                  @cancel="statusPickerShow = false" />
              </van-popup>
            </div>
          </el-col>
          <el-col :span="24">
            <van-field
              readonly
              clickable
              name="calendar"
              :value="dateArr"
              label="期望预约时间"
              placeholder="请选择日期"
              @click="showCalendar = true" />
            <van-calendar
              v-model="showCalendar"
              :allowSameDay="true"
              type="range"
              :minDate="minDate"
              @confirm="onConfirm" />
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="appointment-history__content">
      <div class="appointment-history__content__list">
        <template v-if="bookingList.length > 0">
          <div
            class="appointment-history__content__item"
            v-for="item in bookingList"
            :key="item.id"
            @click="onClick(item)">
            <div class="appointment-history__content__item-left">
              <div>
                <strong>
                  {{ item.his_user_name }}
                </strong>
                <span>
                  {{ item.his_user_sex_name }}
                </span>
                <span>
                  {{ hidePhone(item.his_user_mobile) }}
                </span>
                <span> {{ item.his_user_level }}级 </span>
              </div>
              <div>
                <strong> {{ item.doctors_head }} </strong>
                <span> {{ item.doctors_name }} </span>
                <span> {{ item.doctor_title }} </span>
              </div>
              <template v-if="item.booking_mode === 1">
                <div>
                  <strong> {{ item.booking_date }} </strong>
                  <strong> {{ item.booking_time_str }} </strong>
                </div>
                <div>
                  <span> {{ item.year }}，{{ item.week }} </span>
                </div>
              </template>
              <template v-else>
                <strong>
                  {{
                    item.booking_time_str
                      ? item.booking_time_str
                      : "按照医生出诊时间"
                  }}
                </strong>
              </template>
            </div>
            <div class="appointment-history__content__item-right">
              <div
                class="appointment-history__content__item-right-status"
                :class="statusColor[item.booking_status]">
                {{ item.booking_status_name }}
              </div>
              <template v-if="item.booking_status != 2">
                <el-button type="primary" size="mini" @click.stop="cancel(item)"
                  >取消</el-button
                >
              </template>
            </div>
            <div
              class="appointment-history__content__item-type"
              :style="{
                backgroundColor:
                  item.booking_mode == 1
                    ? '#2CC03C'
                    : item.booking_mode == 2
                    ? '#3894FF'
                    : '#F0943E',
              }">
              {{ item.booking_type_name }}
            </div>
          </div>
        </template>
        <van-empty description="暂无数据" v-else />
      </div>
    </div>
  </div>
</template>

<script>
import bookingDiagnoseService from "@/apis/bookingDiagnose/index.js";
import getUserInfo from "@/models/userInfo";
import { Dialog } from "vant";
import { Message } from "element-ui";
import keyMap from "@/constants/appointment.js";
import { formatDate } from "@/utils/utils";

export default {
  name: "history",
  data() {
    return {
      value: "",
      search: "",
      statusColor: {
        0: "appointment-history__content__item-right-status-orange",
        1: "appointment-history__content__item-right-status-green",
        2: "appointment-history__content__item-right-status-red",
      },
      form: {
        booking_type: null,
        booking_status: null,
        booking_sdate: null,
        booking_edate: null,
        filter: "",
      },
      bookingList: [],
      bookingType: "全部",
      typePickerShow: false,
      typeList: [
        {
          label: "全部",
          value: undefined,
        },
        {
          label: "专家预约",
          value: 1,
        },
        {
          label: "分诊",
          value: 2,
        },
      ],
      bookingStatus: "全部",
      statusPickerShow: false,
      statusList: [
        {
          label: "全部",
          value: undefined,
        },
        {
          label: "预约中",
          value: 0,
        },
        {
          label: "预约成功",
          value: 1,
        },
        {
          label: "已取消",
          value: 2,
        },
      ],
      showCalendar: false,
      dateArr: "",
      currentUserInfo: {},
      minDate: new Date(2017, 1, 1),
    };
  },
  async mounted() {
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
    this.getList();
  },
  methods: {
    getList() {
      const { currentUserInfo } = this;
      const loading = this.$loading({
        lock: true,
        text: "加载中，请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params = {
        ...this.form,
        submit_user_id: currentUserInfo.user_id,
      };
      bookingDiagnoseService.bookingDiagnoseList(params).then((res) => {
        this.bookingList = res;
        loading.close();
      });
    },
    onTypePickerConfirm(e) {
      this.bookingType = e.label;
      this.form.booking_type = e.value;
      this.typePickerShow = false;
      this.getList();
    },
    onStatusPickerConfirm(e) {
      this.bookingStatus = e.label;
      this.form.booking_status = e.value;
      this.statusPickerShow = false;
      this.getList();
    },
    onSearch() {
      this.getList();
    },
    onClick(item) {
      console.log(item);
      if (
        item.booking_mode == keyMap.appointment &&
        item.booking_type == keyMap.appointment
      ) {
        return;
      }
      this.$router.push({
        name: "WorkOrderDetail",
        query: {
          type: "normal",
          id: item.work_id,
        },
      });
    },
    onConfirm(event) {
      this.showCalendar = false;
      this.form.booking_sdate = formatDate(event[0]);
      this.form.booking_edate = formatDate(event[1]);
      this.dateArr = `${formatDate(event[0])} ～ ${formatDate(event[1])}`;
      this.getList();
    },
    // 隐藏手机号中间4位
    hidePhone(phone) {
      return phone?.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },
    cancel(item) {
      let msg = item.booking_mode === keyMap.appointment ?
      `请确认是否要取消 ${item.his_user_name} ${item.year}${item.booking_date} ${item.booking_time_str}的${item.doctors_head}的预约记录？`
      : `请确认是否要取消 ${item.his_user_name} ${item.booking_time_str}${item.doctors_head}的预约记录？`
      Dialog.confirm({
        title: +item.booking_type === 1 ? "取消预约" : "取消分诊",
        message: msg,
      })
        .then(() => {
          bookingDiagnoseService
            .bookingDiagnoseCancel({
              id: item.id,
              submit_user_id: this.currentUserInfo.user_id,
              submit_user_name: this.currentUserInfo.user_name,
            })
            .then(() => {
              Message({
                message: "取消成功",
                type: "success",
              });
              this.getList();
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.appointment-history {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  .van-field__value {
    border: 1px solid #eee;
  }
  .appointment-history__header {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 10px;
    flex-shrink: 0;

    .appointment-history__header__search {
      width: 100%;
    }
  }
  .appointment-history__content {
    padding: 10px 10px;
    .appointment-history__content__list {
      .van-cell {
        margin-bottom: 10px;
      }
    }
  }
}
.appointment-history__content {
  flex: 1;
  overflow: auto;
  border-top: 2px solid #eee;
}
.appointment-history__content__item {
  border-bottom: 2px solid #eee;
  padding: 10px 15px 10px 10px;
  display: flex;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  align-items: center;
  .appointment-history__content__item-left {
    span,
    strong {
      margin-right: 10px;
    }
    div {
      margin-bottom: 5px;
    }
    span {
      font-size: 14px;
      color: #999;
    }
  }
  .appointment-history__content__item-right {
    width: 83px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .el-button {
      margin-top: 10px;
    }
    .appointment-history__content__item-right-status {
      font-size: 16px;
      font-weight: bold;
    }
    .appointment-history__content__item-right-status-orange {
      color: orange;
    }
    .appointment-history__content__item-right-status-green {
      color: green;
    }
    .appointment-history__content__item-right-status-red {
      color: red;
    }
  }
  .appointment-history__content__item-type {
    position: absolute;
    top: -10px;
    right: -40px;
    font-size: 12px;
    transform: rotateZ(45deg);
    background-color: orange;
    height: 40px;
    width: 100px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
